/* @flow */
import { css } from 'linaria';
import * as React from 'react';

import AppStoreBadges from '../../components/AppStoreBadges';
import { BecomeALuggerBlock, ThreeFeaturesBlock, ReviewBlock } from '../components';
import {
  BodyText,
  Container,
  FeatureBlock,
  Grid,
  GridCell,
  Icon,
  Illustration,
  Image,
  SectionTitle,
  Spacer,
  SteppedFeatureBlock,
  Title,
} from '../../components/core';
import Colors from '../../constants/Colors';
import Hero from '../../components/Hero';
import { HomePageReviews, Banner } from './components';
import MediaQueries from '../../constants/MediaQueries';
import { Page, PageBody, PageHelmet } from '../../components/chrome';
import Responsive from '../../constants/Responsive';
import { ResponsiveEstimateForm } from '../../components/EstimateForm';
import Reviews, { getReviewTagged } from '../../../data/Reviews';
import Road from '../../components/Road';
import ServiceCard from '../../components/ServiceCard';
import ZIndex from '../../constants/ZIndex';

class HomePage extends React.Component<{}> {
  static metadata = {};

  render() {
    return (
      <Page>
        <PageHelmet page={HomePage} />
        <Hero
          className={Styles.Hero}
          backgroundImageSrc={require('../../../assets/images/header-photos/home.jpg')}
          backgroundImageSrc2x={require('../../../assets/images/header-photos/home_2x.jpg')}>
          <Container size="large" padded={true}>
            <Banner />
          </Container>
          <Container padded={true}>
            <div className={Styles.HeroTitleContainer}>
              <Image
                src={require('../../../assets/images/homepage-title.svg')}
                className={Styles.HeroTitle}
              />
              <Title color={Colors.White} size="40" weight="light" className={Styles.HeroSubtitle}>
                with the push of a button
              </Title>
            </div>
          </Container>
          <Container size="large" padded={true}>
            <ResponsiveEstimateForm />
          </Container>
          <Spacer size={100} />
          <Container padded={true} align="center">
            <HomePageReviews theme="dark" />
          </Container>
          <Spacer size={100} />
          <Container padded={true} className={Styles.HeroServicesContainer}>
            <Grid hAlign="center" equalHeight={true} className={Styles.ServicesGrid}>
              <GridCell size={Responsive('size6of12', 'size4of12')} style={{ padding: 12 }}>
                <ServiceCard
                  path="/services/store-delivery"
                  title="Store delivery"
                  icon={<Icon name="price-tag" />}
                  description="Delivered in as little as 30 minutes."
                />
              </GridCell>
              <GridCell size={Responsive('size6of12', 'size4of12')} style={{ padding: 12 }}>
                <ServiceCard
                  path="/services/small-moves"
                  title="Small moves"
                  icon={<Icon name="home" />}
                  description="Save time, take back your weekend."
                />
              </GridCell>
              <GridCell size={Responsive('size6of12', 'size4of12')} style={{ padding: 12 }}>
                <ServiceCard
                  path="/services/craigslist-delivery"
                  title="Craigslist delivery"
                  icon={<Icon name="handshake" />}
                  description="Buy & sell without leaving the house."
                />
              </GridCell>
              <GridCell size={Responsive('size6of12', 'size4of12')} style={{ padding: 12 }}>
                <ServiceCard
                  path="/services/storage-moves"
                  title="Storage moves"
                  icon={<Icon name="storage" />}
                  description="To and from storage without a sweat."
                />
              </GridCell>
              <GridCell size={Responsive('size6of12', 'size4of12')} style={{ padding: 12 }}>
                <ServiceCard
                  path="/services/donations"
                  title="Donations"
                  icon={<Icon name="donation" />}
                  description="Get rid of your unwanted."
                />
              </GridCell>
              <GridCell size={Responsive('size6of12', 'size4of12')} style={{ padding: 12 }}>
                <ServiceCard
                  path="/services/junk-removal"
                  title="Junk removal"
                  icon={<Icon name="junk-removal" />}
                  description="Junk it all."
                />
              </GridCell>
            </Grid>
          </Container>
          <div className={Styles.HeroWhiteout} />
        </Hero>
        <PageBody>
          <Container align="center" padded={true}>
            <SectionTitle title="We've got your back" subtitle="We load, haul & deliver anything" />
            <Spacer size={80} />
            <FeatureBlock
              layout="horizontal"
              horizontalFigurePosition="left"
              figure={
                <div className={Styles.PhotoFrame}>
                  <Image
                    src={require('../../../assets/images/photos/luggers-small-01_2x.jpg')}
                    style={{ width: '100%' }}
                  />
                </div>
              }
              title={<SectionTitle title="Two strong Luggers" />}
              body={
                <BodyText size="16">
                  Every Lugg comes with 2 strong professional luggers who are vetted for a 5-star
                  experience. They will do the impossible to load, haul and deliver your items
                  safely.
                </BodyText>
              }
            />
            <Container size="smallest">
              <Spacer size={200} color={Colors.Divider} />
            </Container>
            <FeatureBlock
              layout="vertical"
              figure={<Illustration name="vehicle-lineup" />}
              title={<SectionTitle title="A truck as big as you need" />}
              body={
                <BodyText size="16">
                  Ranging from Pickup Trucks to Cargo Vans and Sprinter Vans.
                </BodyText>
              }
            />
            <Container size="smallest">
              <Spacer size={200} color={Colors.Divider} />
            </Container>
            <SectionTitle title="Save time & energy" />
            <Spacer size={50} />
            <ThreeFeaturesBlock />
          </Container>
          <Container size="large" padded={true}>
            <Spacer size={200} color={Colors.Divider} />
          </Container>
          <Container padded={true} align="center">
            <SectionTitle title="Here's how it works" subtitle="Anything moved in 3 easy steps" />
            <Spacer size={120} />
            <SteppedFeatureBlock
              layout="vertical"
              figure={<Illustration name="hand-with-couch" />}
              step="1"
              title={<SectionTitle title="Request in the app" />}
              body={
                <div>
                  <BodyText size="16">
                    Set your pickup location and destination, choose the size of vehicle that is
                    right for you, and when you would like us to arrive.
                  </BodyText>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <AppStoreBadges />
                  </div>
                </div>
              }
            />
            <Road enrouteTo="pickup-short" />
            <SteppedFeatureBlock
              layout="horizontal"
              horizontalFigurePosition="right"
              figure={<Illustration name="female-customer-handshake" />}
              step="2"
              title={<SectionTitle title="Don't lift a finger" />}
              body={
                <BodyText size="16">
                  {
                    "We'll take it from here. Two strong Luggers arrive to load your stuff and secure it safely. We'll see you at your destination!"
                  }
                </BodyText>
              }
            />
            <Road enrouteTo="dropoff" />
            <SteppedFeatureBlock
              layout="horizontal"
              horizontalFigurePosition="left"
              figure={<Illustration name="female-customer-rate-and-tip" />}
              step="3"
              title={<SectionTitle title="Rate and tip" />}
              body={
                <BodyText size="16">
                  {
                    'We unload your items and place them right where you want them. Tell us about your experience and tip your Luggers for a job well done.'
                  }
                </BodyText>
              }
            />
          </Container>
          <Container size="large" padded={true}>
            <Spacer size={200} color={Colors.Divider} />
          </Container>
          <Container padded={true} align="center">
            <ReviewBlock review={getReviewTagged(Reviews, 'home-page')} />
          </Container>
          <Spacer size={120} />
          <Container size="large" padded={true}>
            <BecomeALuggerBlock />
          </Container>
        </PageBody>
      </Page>
    );
  }
}

const Styles = {
  Hero: css``,
  HeroWhiteout: css`
    background-color: #fff;
    bottom: 0;
    position: absolute;
    left: 0;
    right: 0;
    height: 160px;
  `,
  HeroTitle: css`
    width: 100%;
    max-width: 553px;
  `,
  HeroSubtitle: css`
    margin-top: 15px;
  `,
  HeroTitleContainer: css`
    text-align: center;
    padding: 80px 0 50px;
    ${MediaQueries.Medium} {
      padding: 100px 0 80px;
    }
  `,
  HeroServicesContainer: css`
    position: relative;
    z-index: ${ZIndex.Higher};
  `,
  ServicesGrid: css`
    margin-left: -12px;
    margin-right: -12px;
  `,
  PhotoFrame: css`
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border-radius: 10px;
  `,
  InlineFeature: css`
    margin-bottom: 56px;
  `,
};

export default HomePage;



// WEBPACK FOOTER //
// ./src/ui/pages/HomePage/HomePage.js